import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export type RowActionTone = 'default' | 'destructive';

const BUTTON_VARIANT_BY_TONE = {
  default: 'outline',
  destructive: 'destructive',
} as const satisfies Record<RowActionTone, 'outline' | 'destructive'>;

const DISABLED_HINT_TRIGGER_CLASS =
  'inline-flex cursor-not-allowed rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ring/50 [&_button:disabled]:pointer-events-none';

interface RowActionButtonProps {
  label: string;
  ariaLabel: string;
  onClick: () => void;
  tone?: RowActionTone;
  isDisabled?: boolean;
  disabledHint?: string | undefined;
}

export function RowActionButton({
  label,
  ariaLabel,
  onClick,
  tone = 'default',
  isDisabled = false,
  disabledHint,
}: RowActionButtonProps) {
  const button = (
    <Button
      variant={BUTTON_VARIANT_BY_TONE[tone]}
      size="sm"
      aria-label={ariaLabel}
      disabled={isDisabled}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      {label}
    </Button>
  );

  if (!isDisabled || !disabledHint) return button;

  return (
    <Tooltip>
      <TooltipTrigger
        render={<span />}
        tabIndex={0}
        aria-label={`${ariaLabel}: ${disabledHint}`}
        className={DISABLED_HINT_TRIGGER_CLASS}
      >
        {button}
      </TooltipTrigger>
      <TooltipContent>{disabledHint}</TooltipContent>
    </Tooltip>
  );
}
